export const FreeUseDay = 3;